import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import {
  APIuuid,
  IAPIArrayData,
  IAPIData
} from '@shared/interfaces/api.interface';
import { IComment } from '@shared/interfaces/comment.interface';
import { Comment } from '@shared/models/comment.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {
  private readonly ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/comments`
  );

  private readonly CANDIDATES_ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/candidates`
  );

  private readonly REFERENCES_ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/references`
  );

  constructor(private readonly _http: HttpClient) {}

  public get(): Observable<IComment[]> {
    return this._http
      .get<IAPIArrayData>(this.ENDPOINT_V3)
      .pipe(map((res: IAPIArrayData) => Comment.fromAPIArray(res)));
  }

  public find(id: APIuuid): Observable<IComment> {
    return this._http
      .get<IAPIData>(`${this.ENDPOINT_V3}/${id}`)
      .pipe(map((res: IAPIData) => Comment.fromAPI(res)));
  }

  public getCommentsForCandidate(candidateId: APIuuid): Observable<IComment[]> {
    return this._http
      .get<IAPIArrayData>(`${this.CANDIDATES_ENDPOINT_V3}/${candidateId}/comments`)
      .pipe(map((res: IAPIArrayData) => Comment.fromAPIArray(res)));
  }

  public getCommentsForReference(referenceId: APIuuid): Observable<IComment[]> {
    return this._http
      .get<IAPIArrayData>(`${this.REFERENCES_ENDPOINT_V3}/${referenceId}/comments`)
      .pipe(map((res: IAPIArrayData) => Comment.fromAPIArray(res)));
  }

  public post(body: IAPIData): Observable<IComment> {
    return this._http
      .post<IAPIData>(this.ENDPOINT_V3, body)
      .pipe(map((res: IAPIData) => Comment.fromAPI(res)));
  }

  public patch(id: APIuuid, body: IAPIData): Observable<IComment> {
    return this._http
      .patch<IAPIData>(`${this.ENDPOINT_V3}/${id}`, body)
      .pipe(map((res: IAPIData) => Comment.fromAPI(res)));
  }

  public delete(id: APIuuid): Observable<IComment> {
    return this._http
      .delete<IAPIData>(`${this.ENDPOINT_V3}/${id}`)
      .pipe(map((res: IAPIData) => Comment.fromAPI(res)));
  }
}
